import React from "react";

function Selector({ handleValue }: any) {
  return (
    <div className="text-center" style={{ marginBottom: "30px" }}>
      Wybierz województwo z którego chcesz znaleźć partnera:&nbsp;
      <select
        onChange={(e) => handleValue(e.target.value)}
        style={{ maxWidth: "300px", display: "inline-block" }}
      >
        <option value="all">Cała Polska</option>
        <option value="Dolnośląskie">Dolnośląskie</option>
        <option value="Kujawsko-pomorskie">Kujawsko-pomorskie</option>
        <option value="Lubelskie">Lubelskie</option>
        <option value="Lubuskie">Lubuskie</option>
        <option value="Łódzkie">Łódzkie</option>
        <option value="Małopolskie">Małopolskie</option>
        <option value="Mazowieckie">Mazowieckie</option>
        <option value="Opolskie">Opolskie</option>
        <option value="Podkarpackie">Podkarpackie</option>
        <option value="Podlaskie">Podlaskie</option>
        <option value="Pomorskie">Pomorskie</option>
        <option value="Śląskie">Śląskie</option>
        <option value="Świętokrzyskie">Świętokrzyskie</option>
        <option value="Warmińsko-mazurskie">Warmińsko-mazurskie</option>
        <option value="Wielkopolskie">Wielkopolskie</option>
        <option value="Zachodnio-pomorskie">Zachodnio-pomorskie</option>
      </select>
    </div>
  );
}

export default Selector;
